<template>
  <div>
    <section class="section">
      <HeaderSection :title="$t('views.account.password')"/>
      <div class="section-content is-large">
        <form class="forms row" @submit.prevent="submit">
          <div class="col-tab-12" v-if="errors.non_field_errors">
            <div class="col-tab-12 alert is-warning mb-10 is-center-aligned">
              {{ errors.non_field_errors[0] }}
            </div>
          </div>
          <div class="col-tab-6">
            <VqInput
              :label="$t('views.account.form.currentPassword')"
              name="password"
              type="password"
              :errors="errors.current_password"
              v-model="formData.current_password"
            />
          </div>
          <div class="col-tab-12 mt-10">
            <div class="row">
              <VqInput
                  classes="col-tab-6"
                  :label="$t('views.account.form.newPassword1')"
                  name="new_password1"
                  type="password"
                  :errors="errors.new_password1"
                  v-model="formData.new_password1"
              />
              <VqInput
                  classes="col-tab-6 mt-10 mt-n-tab"
                  :label="$t('views.account.form.newPassword2')"
                  name="new_password2"
                  type="password"
                  :errors="errors.new_password2"
                  v-model="formData.new_password2"
              />
            </div>
          </div>
          <div class="col-tab-12 is-right-aligned">
            <button
              :class="{'is-loading': isFormLoading}"
              class="button is-small is-gamma mt-20">
              {{ $t('views.account.form.cta') }}
            </button>
          </div>
        </form>
      </div>
    </section>

    <section class="section">
      <HeaderSection :title="$t('views.account.title')"/>
      <div class="section-content is-large">
        <div class="forms row items-center">
          <VqToggleBtn
            classes="col-tab-6"
            name="email_notif"
            :label="$t('views.account.emailNotif')"
            v-model="email_notification"
            option-true="ON"
            option-false="OFF"
            v-on:change="editMailNotif"
          />
          <VqToggleBtn
            v-if="hasAgilityAccess"
            classes="col-tab-6"
            name="zabbix_email_notif"
            :label="$t('views.account.zabbixEmailNotif')"
            v-model="zabbix_notiffication"
            option-true="ON"
            option-false="OFF"
            v-on:change="editZabbixMailNotif"
          />
          <VqSelect
            classes="col-tab-6"
            name="lang"
            v-model="locale"
            :optionValueAttr="'code'"
            :optionLabelAttr="'name'"
            :label="$t('views.account.form.lang')"
            :options="locales"
            v-on:change="changeLocale"
          />
        </div>
      </div>
    </section>

    <section class="section">
      <HeaderSection :title="$t('views.account.ips')"/>
      <div class="section-content is-large">
        <div>
          <p
            v-for="ip in ips"
            :key="ip.id"
            class="badge is-large is-gray-100 mr-5 mt-5">[{{ip.created_format}}] {{ ip.ip }}</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import USERS from '@/api/users';
import AUTH from '@/api/auth';

import { eventHubMixin } from '@/mixins/event';

import HeaderSection from '@/components/HeaderSection.vue';
import VqInput from '@/components/VqInput.vue';
import VqSelect from '@/components/VqSelect.vue';
import VqToggleBtn from '@/components/VqToggleBtn.vue';
import { getSupportedLocales } from "@/utils/i18n/supported-locales"

export default {
  name: 'account',
  mixins: [eventHubMixin],
  components: {
    HeaderSection,
    VqInput,
    VqSelect,
    VqToggleBtn,
  },
  data: () => ({
    formData: {},
    ips: [],
    errors: {},
    locale: null,
    locales: getSupportedLocales(),
    email_notification: false,
    isFormLoading: false,
    zabbix_notiffication: false,
  }),
  computed: {
  },
  created() {
    this.getLastIP();
    this.getEmailNotif();
    this.getZabbixEmailNotif();
  },
  mounted() {
    this.locale = this.$i18n.locale
  },
  computed: {
    ...mapGetters({
      hasAgilityAccess: 'auth/hasAgilityAccess',
    }),
  },
  methods: {
    changeLocale(e) {
      const locale = e
      this.$router.replace({ name: this.$route.name, params: { locale: locale } })
      this.$forceUpdate()
    },
    initFormData() {
      this.formData = {
        current_password: '',
        new_password1: '',
        new_password2: '',
      };
    },
    initErrors() {
      this.errors = {
        non_field_errors: '',
        current_password: '',
        new_password1: '',
        new_password2: '',
      };
    },
    emitPasswordChangeToaster() {
      this.emitAddToaster({
        title: this.$t('views.account.toasts.password.title'),
        text: this.$t('views.account.toasts.password.content'),
        state: 'success',
        // 'link': 'http://telecloud.fr'
      });
    },
    submit() {
      this.isFormLoading = true;
      this.initErrors();
      AUTH.passwordChange(this.formData).then(
        (res) => {
          this.isFormLoading = false;
          this.emitPasswordChangeToaster();
          this.initFormData();
        },
        (err) => {
          this.isFormLoading = false;
          this.errors = err.response.data;
        },
      );
    },

    emitMailNotifToaster() {
      this.emitAddToaster({
        title: this.$t('views.account.toasts.emailNotif.title'),
        text: this.$t('views.account.toasts.emailNotif.content'),
        state: 'success',
        // link: 'http://telecloud.fr',
      });
    },

    emitZabbixMailNotifToaster() {
      this.emitAddToaster({
        title: this.$t('views.account.toasts.zabbixEmailNotif.title'),
        text: this.$t('views.account.toasts.zabbixEmailNotif.content'),
        state: 'success',
        // link: 'http://telecloud.fr',
      });
    },

    getEmailNotif() {
      USERS.getMailNotif().then(
        (res) => {
          this.email_notification = res.data.email_notification;
        },
        (err) => {
          this.errors = err.response.data;
        },
      );
    },

    editMailNotif() {
      USERS.editMailNotif({ email_notification: this.email_notification }).then(
        (res) => {
          this.emitMailNotifToaster();
        },
        (err) => {
          this.errors = err.response.data;
        },
      );
    },

    getZabbixEmailNotif() {
      USERS.getZabbixEmailNotif().then(
        (res) => {
          this.zabbix_notiffication = res.data.email_notification;
        },
        (err) => {
          this.errors = err.response.data;
        },
      );
    },

    editZabbixMailNotif() {
      USERS.editZabbixMailNotif({ email_notification: this.zabbix_notiffication }).then(
        (res) => {
          this.emitZabbixMailNotifToaster();
        },
        (err) => {
          this.errors = err.response.data;
        },
      );
    },

    getLastIP() {
      USERS.ips().then(
        (res) => {
          this.ips = res.data.results;
        },
        (err) => {
          this.errors = err.response.data;
        },
      );
    },
  },
};
</script>
